import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PAYMENT_METHOD } from "./apiRoutes";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getPaymentMethodByCommunity = async (communityId: string) => await axiosAuth.get(`${PAYMENT_METHOD}/community/${communityId}`);

const useGetPaymentMethodByCommunity = ({communityId, queryParams}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-method", communityId],
    queryFn: () => getPaymentMethodByCommunity(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPaymentMethodByCommunity;
